
import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { DensityStyleTypes } from 'types'
import { useNavigate } from 'react-router-dom'

interface ContractedByCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}
export default function ContractedByCell({ params, densityStyles }: ContractedByCellProps): JSX.Element {
  const navigate = useNavigate()
  const { isParent, contractedByOrg } = params?.row ?? {}
  // const contractedByOrg = organizations?.find(org => org?.org_uuid === contractedBy?.[0]) ?? null
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          paddingTop: densityStyles?.padding,
          paddingBottom: densityStyles?.padding,
          paddingRight: densityStyles?.padding,
          gap: densityStyles?.gap,
          width: '100%',
          cursor: 'pointer',
        }}
        onClick={() => navigate(params?.value ? `/organizations/${contractedByOrg?.PK}/details` : '#')}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            alignItems: 'center',
            height: '100%',
            padding: 1,
            gap: 1,
          }}
        >
          {isParent ? (
            <>
              {/* {contractedByOrg?.photoUrl ? (
                <Avatar
                  src={contractedByOrg?.photoUrl}
                  sx={{
                    width: densityStyles?.avatarSize,
                    height: densityStyles?.avatarSize,
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                  alt={params.value}
                />
              ) : (
                <Avatar
                  {...stringAvatar(params.value, densityStyles)}
                  sx={{
                    backgroundColor: 'rgb(114, 229, 218)',
                    width: densityStyles?.avatarSize,
                    height: densityStyles?.avatarSize,
                  }}
                  alt={params.value}
                />
              )} */}
              <Typography
                sx={{
                  fontSize: densityStyles.fontSize,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }}
              >
                {params?.value ?? 'No Organization Assigned'}
              </Typography>
            </>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                padding: 1,
                gap: 1,
              }}
            >
              –
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}
